import { useMemo } from 'react';

const useMenuIds = ({ menuId }: { menuId: number }) => {
  const menuContainerId = useMemo(() => `Menu${menuId}Container`, [menuId]);

  return {
    menuContainerId,
  };
};

export default useMenuIds;
